module.exports = __webpack_public_path__ + "./fonts/Poppins-Regular-400.ttf";